import type { FunctionComponent } from 'react';
import { useMediaQuery } from 'react-responsive';
import { getPathname } from '../../../utils/location';
import type { ProgressNavProps } from './types';
import * as styles from './ProgressNav.module.css';

const ProgressNav: FunctionComponent<ProgressNavProps> = ({ steps }) => {
  const isDesktop = useMediaQuery({
    query: '(min-width: 992px)',
  });

  const currentNodeIndex = steps.findIndex((step) => {
    const path = getPathname();
    return path.endsWith('/') ? path === `${step.url}/` : path === step.url;
  });

  return (
    <div className={`${styles.navigation} ${styles[isDesktop ? 'large' : 'small']}`}>
      {steps.map(({ title }, index) => (
        <div
          key={title}
          className={`${styles.node} ${index <= currentNodeIndex ? styles.selected : ''}`}
          data-testid={`${title}-${index <= currentNodeIndex ? 'selected' : ''}`}
        >
          <div className={styles.circle}>{index + 1}</div>
          <div className={styles.title}>{title}</div>
        </div>
      ))}
    </div>
  );
};

export default ProgressNav;
